import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../..';
import postContato from '../queries/postContato';

export default function usePostContato(onSuccess: () => void) {
  return useMutation((value: any) => postContato(value, () => onSuccess()), {
    onSuccess() {
      queryClient.invalidateQueries();
    },
    onError(err: any) {
      console.log(err.message);
    },
  });
}
